function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fill: "#365DE6",
  fillOpacity: 0.5,
  d: "M3.25 5A2.75 2.75 0 0 1 6 2.25h10A2.75 2.75 0 0 1 18.75 5v5.5a.75.75 0 0 1-1.5 0V5c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h7.5a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 19z"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fill: "#365DE6",
  fillOpacity: 0.5,
  d: "M18 13.25a.75.75 0 0 1 .75.75v.418c1.027.038 2 .795 2 1.915a.75.75 0 0 1-1.5 0c0-.142-.162-.416-.581-.416h-1.506a.5.5 0 0 0-.329.112c-.068.06-.084.117-.084.154a.5.5 0 0 0 .018.149a.3.3 0 0 0 .042.026c.04.02.1.044.193.072l2.418.701c.276.082.63.218.908.513c.3.32.421.73.421 1.173c0 1.067-.956 1.766-1.913 1.766h-.087V21a.75.75 0 0 1-1.5 0v-.418c-1.027-.038-2-.795-2-1.915a.75.75 0 0 1 1.5 0c0 .142.162.416.581.416h1.506a.5.5 0 0 0 .329-.112c.068-.06.084-.117.084-.154a.5.5 0 0 0-.018-.149a.3.3 0 0 0-.042-.026c-.04-.02-.1-.044-.193-.072l-2.418-.701c-.276-.082-.63-.218-.908-.513c-.3-.32-.421-.73-.421-1.173c0-1.067.956-1.766 1.913-1.766h.087V14a.75.75 0 0 1 .75-.75M6.25 11a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m-3 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75m-3 3a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m3 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M6 6.5c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54C6.801 5 7.034 5 7.5 5h7c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54C15.199 8 14.966 8 14.5 8h-7c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C6 7.199 6 6.966 6 6.5"
});
const SvgPlans = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlans, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plans.6e221c0b.svg";
export { ForwardRef as ReactComponent };